module.exports = __webpack_public_path__ + "assets/promo_applied.b748a0d1.svg";